'use strict';

var angular = require('angular');
var XtFormController = function XtFormController($scope, $element, $attrs, xtFormConfig, $window) {
  var vm = this,
    form = $element.controller('form'),
    validationStrategy = $attrs.strategy ? xtFormConfig.getValidationStrategy($attrs.strategy) : xtFormConfig.getDefaultValidationStrategy();

  //polyfill for setSubmitted pre 1.3
  function setSubmitted() {
    if (angular.isFunction(form.$setSubmitted)) {
      form.$setSubmitted();
      return;
    }
    form.$submitted = true;
    $element.addClass('ng-submitted');
  }
  function setUnsubmitted() {
    if (angular.isFunction(form.$setSubmitted)) {
      return;
    }
    form.$submitted = false;
    $element.removeClass('ng-submitted');
  }
  angular.extend(vm, {
    form: form,
    getValidationStrategy: function getValidationStrategy() {
      return validationStrategy;
    },
    tooltipTrigger: $attrs.tooltipTrigger,
    submit: function submit() {
      setSubmitted();

      // focus first error if required
      if (form.$invalid && $attrs.focusError) {
        $window.setTimeout(function () {
          $element.find('.ng-invalid:input:visible:first').focus();
        });
      }
      $scope.$broadcast('XtForm.ForceErrorUpdate', null, 'submit');
    },
    reset: function reset() {
      vm.form.$setPristine();
      vm.form.$setUntouched();
      setUnsubmitted();
      $scope.$broadcast('XtForm.ForceErrorUpdate', null, 'reset');
    }
  });
};
XtFormController.$inject = ['$scope', '$element', '$attrs', 'xtFormConfig', '$window'];
module.exports = XtFormController;